<template>
    <div>
        <div class="d-flex justify-content-between">
            <div class="align-self-center">
                <p class="fw-bold mb-0">{{ $t('E-post') }}</p>
            </div>

            <div class="text-end">
                <input type="text" v-model="userEmail" class="form-control form-control-sm text-end" :class="{'is-invalid': errorMessage || !userEmail.length }" @keyup.enter="save">
            </div>
        </div>
        <div class="text-end mt-2">
            <span class="btn btn-success btn-sm fw-bold px-3 py-2" @click="save" :class="{'disabled':isDisabled}">
                {{ saveLabel }}
                <span v-if="isSaving" class="ml-2 fa fa-spinner fa-spin"></span>
            </span>
        </div>
        <div class="alert alert-danger mt-2" v-show="errorMessage.length">{{ errorMessage }}</div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import ProfileApi from '../../api/Profile'

const props = defineProps(['useremail'])
const userEmail = ref(props.useremail)
const isSaving = ref(false)
const isDisabled = ref(false)
const saveLabel = ref($t('Oppdater'))
const errorMessage = ref('')

const save = () => {
    if (isSaving.value) {
        return;
    }
    isSaving.value = true
    isDisabled.value = true
    saveLabel.value = $t('Oppdaterer...')
    errorMessage.value = ''

    ProfileApi.Update({ email: userEmail.value }).then(res => {
        if (res.success) {
            saveLabel.value = $t('Oppdatert!')
            isSaving.value = false
            setTimeout(() => {
                saveLabel.value = $t('Oppdater')
                isDisabled.value = false
            }, 2000)
            return;
        }

        errorMessage.value = res.message
        saveLabel.value = $t('Oppdater')
        isSaving.value = false
        isDisabled.value = false
    }).catch(e => {
        saveLabel.value = $t('Oppdater')
        isSaving.value = false
        isDisabled.value = false
        errorMessage.value = $t('Det skjedde noe galt. Prøv igjen senere.')
    })
}
</script>